export const ADMIN_DATA_KEY = "sgbv-admin-management-data";

export const EMPTY_ADMIN_DATA = Object.freeze({
  districts: [],
  dutyStations: [],
  mobileUsers: [],
});

export const createAdminId = prefix => {
  const randomPart = typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `${prefix}-${randomPart}`;
};

export const loadAdminData = () => {
  try {
    const storedData = window.localStorage.getItem(ADMIN_DATA_KEY);
    return storedData
      ? { ...EMPTY_ADMIN_DATA, ...JSON.parse(storedData) }
      : { districts: [], dutyStations: [], mobileUsers: [] };
  } catch (error) {
    return { districts: [], dutyStations: [], mobileUsers: [] };
  }
};

export const saveAdminData = data => {
  window.localStorage.setItem(ADMIN_DATA_KEY, JSON.stringify(data));
  return data;
};

export const importDistrictNames = (data, districtNames) => {
  if (data.districts.length > 0) {
    return data;
  }

  return {
    ...data,
    districts: districtNames.map(name => ({
      id: createAdminId("district"),
      name,
      active: true,
      imported: true,
    })),
  };
};
